
import React from 'react';
import './chatLoader.scss';

interface ChatLoaderProps {
  isVisible: boolean;
}

const ChatLoader: React.FC<ChatLoaderProps> = ({ isVisible }) => {
  if (!isVisible) return null;
  
  return (
    <div className="bot-message-row">
      <div className="bot-icon">
        <img className="svg" src="assets/icon/logoIcon.svg" alt="Ionic logo" />
      </div>
      <div className="chat-loader">
        <div className="loading-dots">
          <div className="dot"></div>
          <div className="dot"></div>
          <div className="dot"></div>
        </div>
      </div>
    </div>
  );
};

export default ChatLoader;